import { render, staticRenderFns } from "./EventRegistration.vue?vue&type=template&id=f9b777f0&scoped=true"
import script from "./EventRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./EventRegistration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EventRegistration.vue?vue&type=style&index=0&id=f9b777f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b777f0",
  null
  
)

export default component.exports